import React, { Component, useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import Typo from '../../components/CustomTypo';
import { Grid } from '@material-ui/core';
import { ErrorIcon, SuccessIcon } from '../../components/icons'
import Button from '../../components/ButtonCustom';
import { formatDateTimeToShortMonthName } from '../../utils/util';
import Container from '../../components/Container';
import { getCurrency, getPaymentRecuring, setPaymentRecuring } from '../../utils/common';
import { cignalservices } from '../../wsclient/crmservices/cignalservices';
import ModalAlert from '../../components/ModalAlert';
import Cookies from 'js-cookie';
import { connection } from '../../../portal.config';
import crmservices from '../../wsclient/crmservices';
import ButtonCustom from '../../components/ButtonCustom';
import { paths } from '../../../portal.router.config';
import { airlinkservices } from '../../wsclient/crmservices/airlinkservices';
import { payment } from '../../wsclient/crmservices/payment';
const queryString = require('query-string');

function FACResult(props) {
    const { classes, t } = props;

    const [showLoading, onShowLoading] = useState(true);
    const [message, setMessage] = useState({});
    const [ready, setReady] = useState(true);
    const [payload, setPayload] = useState(null);
    const [facResult, setFACResult] = useState(null);
    const [crmResult, setCRMResult] = useState(null);
    const [account, setAccount] = useState(null);

    const paymentRecuringData = getPaymentRecuring();

    useEffect(() => {
        getAccountBalance();
    },[]);

    useEffect(() => {
        if (account) onLoad();
    },[account])

    const getAccountBalance = async () => {
        try {
            let result = await crmservices.account.getWalletInfo();
            console.log("AAAA getAccountBalance result: ", result)
            if (result.code == 'OK') {
                setAccount(result.data)
            }
        } catch (error) {
            console.log("AAAA getAccountBalance error: ", error)
        }
    }

    const onLoad = async () => {
        var url = new URL(window.location.href);
        console.log("url===", url);
        var clientTokenId = url.searchParams.get("ID");
        var respCode = url.searchParams.get("RespCode");
        var reasonCode = url.searchParams.get("ReasonCode");

        let payload = {
            nonce: clientTokenId,
            name: 'FAC',
            respCode: respCode,
            reasonCode: reasonCode,
        };
        setPayload(payload);
        let resultMapping = mappingCodeFAC(respCode, reasonCode);
        console.log("resultMapping:",resultMapping);
        console.log("paymentRecuringData:",paymentRecuringData);
        if(resultMapping && resultMapping.success){
            setReady(true);
            if (paymentRecuringData && paymentRecuringData.type == 'TOPUP') {
                let _amount = paymentRecuringData && paymentRecuringData.amount;
                if(account.overdue_amount > 0 && account.overdue_amount < paymentRecuringData.amount) {
                    _amount = account.overdue_amount
                }
                if (paymentRecuringData && paymentRecuringData.is_recurring) {
                    await onAddPaymentMethod(payload);
                    if (paymentRecuringData && paymentRecuringData.amount) {
                        await onCreateTopup({
                            token: payload.nonce,
                            amount: _amount,//fake data
                            transaction_id: clientTokenId,
                            status: respCode === '1' ? 'SUCCESS' : 'FAIL',                            
                        });
                    }
                } else {
                    if (paymentRecuringData && paymentRecuringData.amount) {
                        await onCreateTopup({
                            token: payload.nonce,
                            amount: _amount,//fake data
                            transaction_id: clientTokenId,
                            status: respCode === '1' ? 'SUCCESS' : 'FAIL',
                        });
                    }
                }
            } else {
                if (paymentRecuringData && paymentRecuringData.is_recurring) {
                    await onAddPaymentMethod(payload);
                    if (paymentRecuringData && paymentRecuringData.amount) {
                        await onCreatePayment({
                            token: payload.nonce,
                            amount: paymentRecuringData.amount,//fake data
                            transaction_id: clientTokenId,
                            status: respCode === '1' ? 'SUCCESS' : 'FAIL'
                        });
                    }
                } else {
                    if (paymentRecuringData && paymentRecuringData.amount) {
                        await onCreatePayment({
                            token: payload.nonce,
                            amount: paymentRecuringData.amount,//fake data
                            transaction_id: clientTokenId,
                            status: respCode === '1' ? 'SUCCESS' : 'FAIL'
                        });
                    }
                }
            }
            setFACResult({
                success: true,
            });
        } else {
            setReady(true);
            setFACResult(resultMapping);
        }
        onShowLoading(false);
    }
    const showMessage = async (status, message) => {
        onShowLoading(false);
        setMessage({
            show: status,
            content: message ? message : null
        });
    }

	const onAddPaymentMethod = async (payload) => {
		console.log("payload:", payload);
		let facIntegration = connection.crmConfig.facIntegration;
		let createCustomerResult = await crmservices.paymentgateway.addPaymentMethod({
			name: payload.name,
			integration_id: facIntegration,
			payment_method_nonce_token: payload.nonce,
            payment_method_type: "CARD",
             gateway: null
		});
		console.log('createCustomerResult ===', createCustomerResult)
		if (createCustomerResult.code === 'OK') {
            setCRMResult({
                success: true,
                message: 'CRM Add Payment method successfully',
            });
		}
		else if (createCustomerResult.code === 'CUSTOMER_EMAIL_ALREADY_EXIST') {
			showMessage(true, t('CUSTOMER_EMAIL_ALREADY_EXIST'));
            setCRMResult({
                success: false,
                message: 'Add card failed',
                respCode: createCustomerResult.code,
                description: createCustomerResult.data && createCustomerResult.data.error && createCustomerResult.data.error.message ? createCustomerResult.data.error.message : t('CUSTOMER_EMAIL_ALREADY_EXIST'),
            });
		}
		else {
			showMessage(true, t('EXCEPTION_PROCESS'));            
            setCRMResult({
                success: false,
                message: 'Add card failed',
                respCode: createCustomerResult.data && createCustomerResult.data.code ? createCustomerResult.data.code : '',
                description: createCustomerResult.data && createCustomerResult.data.error && createCustomerResult.data.error.message ? createCustomerResult.data.error.message : t('EXCEPTION_PROCESS'),
            });
		}
	}

    const onCreatePayment = async (payload) => {
        let businessName = document._portalConfig.domainCustomer ? document._portalConfig.domainCustomer : 'airlink';
        let paymentTypeName = document._portalConfig.paymentTypeName;
        if(businessName === 'airlink-al-wired') businessName = 'airlinkaw';
        let result = await airlinkservices.createPayment({
            amount: payload.amount,
            transaction_id: payload.transaction_id,
            status: payload.status,
            organisation: businessName,
            type_name: paymentTypeName,
        });
        console.log('create payment on crm5 ===', result)
        setPaymentRecuring({});
        if (result.code === 'OK' && payload.status === 'SUCCESS') {
            setCRMResult({
                success: true,
                message: 'Payment was submitted successfully.'
            });
        }
        else if (result.code === 'CUSTOMER_EMAIL_ALREADY_EXIST') {     
            setCRMResult({
                success: true,
                message: t('CUSTOMER_EMAIL_ALREADY_EXIST'),
                respCode: result.code,
                description: result.data && result.data.error && result.data.error.message ? result.data.error.message : t('CUSTOMER_EMAIL_ALREADY_EXIST'),
            });
        }
        else {
            setCRMResult({
                success: true,
                message: 'Create payment failed.',
                respCode: result.code,
                description: result.data && result.data.error && result.data.error.message ? result.data.error.message : t('EXCEPTION_PROCESS'),
            });
        }
    }

    const createPaymentSelfService = async () => {
        try {
            let result = await payment.createPayment({
                amount: Number(paymentRecuringData.amount),
                account_id: paymentRecuringData.account_id,
                payment_method: {
                    type: 'CRM_WALLET',
                },
                external_payable: [{
                    reference: new Date().getTime(),
                }],
                notes: 'Airlink Portal create payment',
            })
            console.log("AAAA createPaymentSelfService result: ", result)
            if (result.code == 'OK') {
                setCRMResult({
                    success: true,
                    message: 'Payment was submitted successfully.'
                });
            } else {
                setCRMResult({
                    success: true,
                    message: 'Create payment failed.',
                    respCode: result.code,
                    description: result.data && result.data.error && result.data.error.message ? result.data.error.message : t('EXCEPTION_PROCESS'),
                });
            }
        } catch (error) {
            console.log("AAAA createPaymentSelfService error: ", error)
        }
    }

    const onCreateTopup = async (payload) => {
        onShowLoading(true)
        let businessName = document._portalConfig.domainCustomer ? document._portalConfig.domainCustomer : 'airlink';        
        if(businessName === 'airlink-al-wired') businessName = 'airlinkaw';
        try {
            let result = await airlinkservices.createTopup({
                amount: payload.amount,
                transaction_id: payload.transaction_id,
                status: payload.status,
                organisation: businessName,
                wallet_id: paymentRecuringData.wallet_id,
            })
            console.log("AAAA createTopups result: ", result)
            if (result.code == 'OK') {
                if (account.balance > 0) await createPaymentSelfService();
                else {
                    setCRMResult({
                        success: true,
                        message: 'Top Up was created successfully.',
                    })
                }
                setPaymentRecuring({})
            } else {
                setCRMResult({
                    success: true,
                    message: 'Create topup failed.',
                    respCode: result.code,
                    description: result.data && result.data.error && result.data.error.message ? result.data.error.message : t('EXCEPTION_PROCESS'),
                });
            }
        } catch (error) {
            console.log("AAAA onCreateTopup error: ", error)
        }
        onShowLoading(false)
    }
    console.log("AAAA facResult:", facResult);
    console.log("AAAA crmResult:", crmResult);
    if (ready)
        return (
            <Container showLoading={showLoading}>
                <Grid xs={12} item>
                    <Grid xs={12} item justify='center' container>
                       {facResult && facResult.success && crmResult && crmResult.success && <SuccessIcon style={{ width: 100, height: 100 }} />} 
                       {((facResult && !facResult.success) || (crmResult && !crmResult.success)) && <ErrorIcon style={{ width: 100, height: 100 }} />} 
                    </Grid>
                    <Grid xs={12} item justify='center' container>
                        {facResult && <Grid item xs={12} style={{textAlign: 'center'}}>
                            {facResult.message && <Typo color={facResult.success ? "success" : 'error'} variant="h5" mg_top_xl>{facResult.message}</Typo>}
                            {facResult.description && <Typo color={facResult.success ? "success" : 'error'} variant="subtitle1" mg_top_md>{facResult.description}</Typo>}
                            {facResult.note && <Typo color={facResult.success ? "success" : 'error'} variant="subtitle1" mg_top_md>{facResult.note}</Typo>}
                            {facResult.respCode && facResult.reasonCode && <Typo color={facResult.success ? "success" : 'error'} variant="subtitle1" mg_top_md>{"Error: FAC "} {facResult.reasonCode}</Typo>}
                        </Grid>}
                    </Grid>
                    <Grid xs={12} item justify='center' container>
                        {crmResult && <Grid item xs={12} style={{textAlign: 'center'}}>
                            <Typo color={crmResult.success ? "success" : 'error'} variant="h5" mg_top_xl>{crmResult.message ? crmResult.message : ''}</Typo>
                            <Typo color={crmResult.success ? "success" : 'error'} variant="subtitle1" mg_top_xl>{crmResult.description ? crmResult.description : ''}</Typo>
                            {crmResult.respCode && <Typo color={crmResult.success ? "success" : 'error'} variant="subtitle1" mg_top_md>{"Error: CRM "} {crmResult.respCode}</Typo>}
                        </Grid>}
                    </Grid>
                    <Grid item xs={12} justify='center' container style={{marginTop: 20}}>
                        <ButtonCustom  onClick={() => props.history.push(paths.home)} color="primary">{"Back to Home"}</ButtonCustom>
                    </Grid>
                </Grid>
                {message && <ModalAlert
                    open={message.show}
                    onClose={showMessage}
                    message={message.content}
                />}
            </Container >
        );
    else {
        return (
            <Container showLoading={showLoading}>

            </Container>
        )
    }
}

function mappingCodeFAC(respCode, reasonCode){
    let result = {
        respCode: respCode,
        reasonCode: reasonCode,
        success: false,
        description: '',
        note: '',
        message: ''
    };
    if(respCode === '1' && reasonCode === '1'){
        result = {
            respCode: respCode,
            reasonCode: reasonCode,
            description: 'Normal Approval',
            success: true,
            message: 'Add card successfully.',
        };
    }else{
        if(reasonCode == 'EX01'){
            result.message = 'Add card failed.';
        }else if(reasonCode == 'EX02'){
            result.message = 'Payment failed.';
        }else{
            result.message = "Transaction is declined."
            let reasons = reasonCode.split("-");
            if(reasons && reasons.length > 0){
                let isoCode = reasons[0];
                let errorCode = reasons.length == 1 ? reasons.length[1] : "";
                if(isoCode == "FC3" || isoCode == "34"){
                    result.description = 'Fraud check error.';
                    result.note = 'Fraud check error.'
                }else if(isoCode == "03"){
                    result.description = 'Invalid Merchant.';
                    result.note = 'Not such merchant.';
                }else if(isoCode == "05"){
                    result.description = 'Transaction is declined.';
                    result.note = 'Default decline.';
                }else if(isoCode == "12"){
                    if(errorCode=="315"){
                        result.description = 'Invalid card/currency';
                        result.note = '';
                    }else if(errorCode=="321"){
                        result.description = 'Processing errors';
                        result.note = '';
                    }else if(errorCode=="387"){
                        result.description = 'Duplicate transaction.';
                        result.note = 'Duplicate TransactionIdentifier.';
                    }else if(errorCode=="370"){
                        result.description = 'Transaction mismatch.';
                        result.note = 'Simulator transaction mismatch.';
                    }else if(errorCode=="546"){
                        result.description = '3DS1 error.';
                        result.note = '3DS1 fallback not allowed.';
                    }else if(errorCode=="75"){
                        result.description = 'SPI error.';
                        result.note = '';
                    }else if(errorCode=="758"){
                        result.description = 'HPP error.';
                        result.note = 'Invalid HPP page.';
                    }else{
                        result.description = 'Invalid transaction.';
                        result.note = '';
                    }
                }else if(isoCode == "3D3"){
                    if(['519','618','518','520'].includes(errorCode)){
                        result.description = '3DS1 system error.';
                        result.note = '';
                    }else if(['611','511','532','548','549','510'].includes(errorCode)){
                        result.description = '3DS system error.';
                        result.note = '';
                    }else{
                        result.description = '3DS2 system error.';
                        result.note = '';
                    }
                }else if(isoCode == "57"){
                    result.description = 'Invalid card type.';
                    result.note = '';
                }else if(isoCode == "89"){
                    result.description = 'Failed authentication.';
                    result.note = 'Invalid credentials.';
                }else if(isoCode == "91"){
                    result.description = 'Host timeout or error';
                    result.note = '';
                }else if(isoCode == "96"){
                    result.description = 'Host processing or system error.';
                    result.note = '';
                }else if(isoCode == "97"){
                    result.description = 'Request failed validation.';
                    result.note = '';
                }else{
                    result.description = 'General error.';
                    result.note = '';
                }
            }else{
                result.description = 'System error.';
                result.note = '';
            }
        }
    }
    return result;
}

const styles = theme => ({
    boxItemContent: {
        padding: theme.spacing(5),
        border: '1px solid',
        borderColor: theme.palette.border.transparent,
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(4),
        boxShadow: '1px 2px 10px -6px rgba(0,0,0,0.75)',
        cursor: 'pointer',
    },
});
export default withStyles(styles)(withTranslation()(FACResult));